import Vue from 'vue'
import Vuex from 'vuex'

import catalogPageCommon from '@/shared/stores/catalogPageCommon'
import optionProducts from '@/shared/stores/optionProducts'
import letterJackets from '@/letter-jackets/catalog-details/store.js'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
  firstOptionProduct: window.pageData.catalogDetails.firstOptionProduct,
  isPhotoBookPackage: window.pageData.catalogDetails.isPhotoBookPackage,
  isPreOrder: window.pageData.catalogDetails.isPreOrder,
  mixMatchPhotoSelectionModuleContent: window.pageData.catalogDetails.photoBookModuleContent, // this is a hacky shim to get the Contentful content to the  Mix n' Match components used by the Photo Books component
  packageImage: window.pageData.catalogDetails.packageImage,
  photoBookModuleContent: window.pageData.catalogDetails.photoBookModuleContent,
  selectedFrameId: null,
  showSingleFramePackageValidationError: false,
  singleFramePackageModuleContent: window.pageData.catalogDetails.singleFramePackageModuleContent
}

const mutations = {
  setSelectedFrameId: (state, frameId) => {
    /*
      this is used by the single package frame UI to set the selected frame,
      which in turn is used to validate the package is complete
    */

    state.selectedFrameId = frameId
  },
  setShowSingleFramePackageValidationError: (state, value) => {
    state.showSingleFramePackageValidationError = value
  }
}

const getters = {
  singlePackageFrameIsValid: state => {
    return state.selectedFrameId !== null
  }
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  modules: {
    catalogPageCommon,
    letterJackets,
    optionProducts
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./WebResources/vue/default/catalog-details/store.js